
import { Button } from "@/components/ui/button";
import { Download, Loader2 } from "lucide-react";
import { useCollectionExport } from "@/hooks/useCollectionExport";
import { useUserSettings } from "@/hooks/useUserSettings";

interface CollectionDownloadButtonProps {
  collectionId: string;
  className?: string;
}

export const CollectionDownloadButton = ({ 
  collectionId, 
  className = "" 
}: CollectionDownloadButtonProps) => {
  const { settings } = useUserSettings();
  const { 
    exportCollection, 
    isExporting, 
    isFullyApproved, 
    isCheckingApproval 
  } = useCollectionExport(collectionId);

  if (isCheckingApproval) {
    return (
      <Button 
        variant="outline" 
        disabled 
        className={`${className} opacity-50`}
      >
        <Loader2 className="h-4 w-4 mr-2 animate-spin" />
        Checking status...
      </Button>
    );
  }

  if (!isFullyApproved) {
    return null; // Don't show button if not fully approved
  }

  const exportFormat = String(settings?.export_format || 'csv');

  return (
    <Button
      onClick={() => exportCollection()}
      disabled={isExporting}
      className={`${className} bg-green-600 hover:bg-green-700 text-white border-green-600 dark:bg-green-600 dark:hover:bg-green-700 dark:text-white`}
      variant="default"
    >
      {isExporting ? (
        <>
          <Loader2 className="h-4 w-4 mr-2 animate-spin" />
          Exporting...
        </>
      ) : (
        <>
          <Download className="h-4 w-4 mr-2" />
          Download {exportFormat === 'excel' ? 'Excel' : 'CSV'}
        </>
      )}
    </Button>
  );
};
